import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfirmationOptions } from '../interfaces/confirmation-options';
import { ConfirmationRequest } from '../interfaces/confirmation-request';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {

  private readonly modalSubject =
    new BehaviorSubject<ConfirmationOptions | null>(null);

  readonly modal$ = this.modalSubject.asObservable();
  private readonly queue: ConfirmationRequest[] = [];
  private activeRequest?: ConfirmationRequest;

  open(options: ConfirmationOptions): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.queue.push({
        options: {
          confirmText: 'Confirm',
          cancelText: 'Cancel',
          type: 'info',
          closeOnBackdrop: true,
          ...options
        },
        resolve
      });

      this.processQueue();
    });
  }

  confirm() {
    if (!this.activeRequest)
      return;

    this.activeRequest.options.onConfirm?.();
    this.activeRequest.resolve(true);
    this.finish();
  }

  cancel() {
    if (!this.activeRequest)
      return;

    this.activeRequest.options.onCancel?.();
    this.activeRequest.resolve(false);
    this.finish();
  }

  private processQueue() {
    if (this.activeRequest)
      return;

    if (this.queue.length === 0)
      return;

    this.activeRequest = this.queue.shift();
    this.modalSubject.next(this.activeRequest!.options);
  }

  private finish() {
    this.modalSubject.next(null);
    this.activeRequest = undefined;
    this.processQueue();
  }
}
